import axios from 'axios';
export function performHttpRequest(method, url, data) {
    // Use Axios to make the HTTP request
    return axios({
        method: method,
        url: url,
        data: data
    });
}